export function escapeRegExp(input: string): string {
  return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function makeWordBoundaryRegex(literal: string, flags = "gi"): RegExp {
  const escaped = escapeRegExp(literal);
  const startsWithWord = /^\w/.test(literal);
  const endsWithWord = /\w$/.test(literal);
  const prefix = startsWithWord ? "\\b" : "";
  const suffix = endsWithWord ? "\\b" : "";
  return new RegExp(`${prefix}${escaped}${suffix}`, flags);
}
